import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _selected2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled, keyframes, alpha } from '@mui/system';
import * as COLOR from '../styles/colors/colors';
import * as TYPEGRAPHY from '../styles/typography/typography';
export var ROOT_PREFIX = 'EmbersScaleSelection';
var enterKeyframe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0);\n    opacity: 0.2;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0.6;\n  } \n"])));
var enterKeyframeSelected = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0);\n    opacity: 0.1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0.4;\n  }\n"])));
export var StyledScaleContainer = styled('div')(_defineProperty({}, "&.".concat(ROOT_PREFIX), {
  '&-root': _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    '&.Embers-disabled': _defineProperty({}, ".".concat(ROOT_PREFIX), _defineProperty({
      '&-title': {
        color: COLOR.PROMETHEAN_NEUTRAL_DARK_GREY
      },
      '&-label': {
        color: COLOR.PROMETHEAN_NEUTRAL_DARK_GREY,
        fontWeight: 400,
        cursor: 'default'
      },
      '&-scale-line': {
        borderColor: COLOR.PROMETHEAN_NEUTRAL_DARK_GREY
      },
      '&-dot': {
        borderColor: COLOR.PROMETHEAN_NEUTRAL_DARK_GREY
      },
      '&-dot-area': {
        '&-selected': _defineProperty({}, ".".concat(ROOT_PREFIX, "-dot"), {
          borderColor: COLOR.PROMETHEAN_NEUTRAL_DARK_GREY,
          backgroundColor: COLOR.PROMETHEAN_NEUTRAL_DARK_GREY
        })
      }
    }, "&-focus-area:hover > .".concat(ROOT_PREFIX, "-dot-area"), {
      backgroundColor: 'transparent',
      border: '1px solid transparent'
    }))
  }, ".".concat(ROOT_PREFIX), {
    '&-title': _objectSpread({
      padding: 0,
      margin: 0,
      marginBottom: 14
    }, TYPEGRAPHY.PROMETHEAN_TYPOGRAPHY_BODY)
  })
}));
export var StyledScaleBox = styled('div')(_defineProperty({
  position: 'relative',
  minHeight: 35,
  maxWidth: 'calc(100% - 22px)',
  marginLeft: 4
}, ".".concat(ROOT_PREFIX), {
  '&-scale-line': {
    position: 'absolute',
    top: 3,
    left: 16,
    width: 'calc(100% - 16px)',
    borderBottom: "2px solid ".concat(COLOR.PROMETHEAN_TEXT)
  },
  '&-dots': {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: 1,
    marginLeft: '-5px',
    marginTop: '-1px',
    width: 'calc(100% + 27px)'
  },
  '&-focus-area': _defineProperty({
    display: 'flex',
    marginTop: '-14px',
    alignItems: 'center',
    textAlign: 'center',
    height: 'fit-content',
    flexDirection: 'column',
    border: '2px solid transparent',
    width: 48
  }, "&:hover > .".concat(ROOT_PREFIX, "-dot-area"), {
    backgroundColor: alpha(COLOR.PROMETHEAN_PURPLE_GRAPE, 0.1),
    border: "1px solid ".concat(COLOR.PROMETHEAN_MID_PURPLE),
    // not on touch devices
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }),
  '&-focus-visible': _defineProperty({
    border: "2px solid ".concat(COLOR.PROMETHEAN_BLUE)
  }, "> .".concat(ROOT_PREFIX, "-dot-area"), {
    backgroundColor: alpha(COLOR.PROMETHEAN_PURPLE_GRAPE, 0.1),
    border: "1px solid ".concat(COLOR.PROMETHEAN_MID_PURPLE),
    // not on touch devices
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }),
  '&-dot-area': {
    boxSizing: 'border-box',
    position: 'relative',
    padding: 12,
    // marginTop: -17,
    background: 'transparent',
    border: '1px solid transparent',
    '.MuiTouchRipple': {
      '&-child': {
        backgroundColor: alpha(COLOR.PROMETHEAN_PURPLE_GRAPE, 0.3)
      },
      '&-rippleVisible': {
        animationName: enterKeyframe
      }
    },
    '&-selected': (_selected2 = {}, _defineProperty(_selected2, ".".concat(ROOT_PREFIX, "-dot"), {
      backgroundColor: COLOR.PROMETHEAN_PURPLE_GRAPE,
      borderColor: COLOR.PROMETHEAN_PURPLE_GRAPE
    }), _defineProperty(_selected2, '.MuiTouchRipple', {
      '&-rippleVisible': {
        animationName: enterKeyframeSelected
      }
    }), _selected2)
  },
  '&-dot': {
    display: 'block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    border: "1px solid ".concat(COLOR.PROMETHEAN_TEXT),
    backgroundColor: COLOR.PROMETHEAN_NEUTRAL_WHITE
  },
  '&-label': _objectSpread(_objectSpread(_objectSpread({
    // position: 'absolute',
    cursor: 'pointer',
    // marginTop: 16,
    maxWidth: 44
  }, TYPEGRAPHY.PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), TYPEGRAPHY.PROMETHEAN_TEXT_WRAP), {}, {
    '&-selected': {
      fontWeight: 700
    }
  })
}));